// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__9g5Dr","logoText":"logo_logoText__Ywmff"};